export const Yellow = '#FFDE00';

export const Blue = '#4382CE';
